import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const ExpandableList = ({ isOpen, title, iconComponent, children, onToggle }) => (
	<div className="expandable-list">
		<div
			className={classNames('expandable-list__header', { 'expandable-list__header--open': isOpen })}
			onClick={() => onToggle()}
		>
			<div className="expandable-list__header-icon-container">{iconComponent}</div>

			<span className="expandable-list__title">{title}</span>

			<i className="expandable-list__header-icon"/>
		</div>

		{isOpen && <div className="expandable-list__content">{children}</div>}
	</div>
);

ExpandableList.propTypes = {
	isOpen: PropTypes.bool,
	title: PropTypes.string,
	iconComponent: PropTypes.any,
	onToggle: PropTypes.func
};

export default ExpandableList;
